import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { translations } from '../../../../locales/translations';
import { DisplayBooleanHorizontal } from './DisplayBooleanHorizontal';
import { DisplayFieldHorizontal } from './DisplayFieldHorizontal';
import { useSelector } from 'react-redux';
import {
  selectPreviewMode,
  selectRecurringView,
} from '../slice/selectors';
import { QuoteItemCard } from './QuoteItemCard';
import { Grid } from '@material-ui/core';
import { LoadingIndicator } from '../../../components/LoadingIndicator';
import { biType } from '../../../../locales/types';
import { PreviousRecurringTab } from './PreviousRecurringTab';

export function RecurringItems(props) {
  const { recurringData } = props;
  const recurringView = useSelector(selectRecurringView);
  const [displayData, setDisplayData] = useState(recurringData);
  const [highlightChange, setHighlightChange] = useState(false);
  const previewMode = useSelector(selectPreviewMode);

  React.useEffect(() => {
    if (previewMode && recurringView) {
      setHighlightChange(true);
      setDisplayData(recurringView);
    } else {
      setDisplayData(recurringData);
    }
  }, [previewMode]);

  React.useEffect(() => {
    if (!previewMode) {
      setDisplayData(recurringData);
    } else if (recurringView) {
      setDisplayData(recurringView);
    }
  }, [recurringData]);

  const originalItems = recurringData?.recurringItems ?? [];
  const previewNewItems = displayData?.newItems?.length
    ? displayData.newItems
    : (previewMode && originalItems.length === 0 ? (displayData?.recurringItems ?? []) : []);

  return (
    <Wrapper>
      {displayData ? (
        <div>
          <Grid container className='header'>
            <Grid item xs={12} md={4}>
              <DisplayBooleanHorizontal
                value={displayData.startDateTBC}
                label={translations.contractDetail.startDateTBC}
                displayChange={highlightChange && displayData.startDateTBC !== recurringData?.startDateTBC}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                label={translations.contractDetail.billingCycle}
                value={displayData.billingCycle}
                displayChange={highlightChange && displayData.billingCycle !== recurringData?.billingCycle}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                label={translations.contractDetail.paymentTerms}
                value={displayData.paymentTerms}
                displayChange={highlightChange && displayData.paymentTerms !== recurringData?.paymentTerms}
              />
            </Grid>
          </Grid>
          {originalItems.map((item, index) => (
            <QuoteItemCard key={index} data={item}
                           viewChangeData={recurringView?.recurringItems?.[index] ?? null}
                           displayType={biType.RECURRING} />
          ))}
          {previewMode && previewNewItems.map((item, index) => (
            <QuoteItemCard key={'newItems'+index} data={item} isNewItem={true}
                           viewChangeData={null}
                           displayType={biType.RECURRING} />
          ))}

          <PreviousRecurringTab />
        </div>
      ) : (
        <LoadingIndicator />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: ${p => p.theme.containerBackground};
  font-size: 12px;
  border-radius: 5px;

  .header {
    display: flex;
    margin-bottom: 5px;
  }

  .previous-recurr {
    padding-top: 5px;
    font-size: 14px;
  }

  .MuiAccordionSummary-root {
    height: 50px;
  }

  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 50px;
  }

  .MuiAccordion-root.Mui-expanded {
    margin: 0;
  }

  .accordion-summary {
    border-radius: 5px !important;
    font-size: 14px;
    background-color: ${p => p.theme.borderLight};
    border: 1px solid ${p => p.theme.textSecondary};
  }

  .recurring-item-container {
    width: 100%;
  }
`;
